var map = {
	"./dark/status/01dailyActive/07target.svg": "UJ7g",
	"./light/status/01dailyActive/07target.svg": "voOp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VGPi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/status\/01dailyActive\/07target\.svg$
// module id = VGPi
// module chunks = 0